import styled from "styled-components";
import { Tooltip } from "react-tooltip";

import tipIcon from "assets/img/icons/icons8-info.svg";

const TipIcon = styled.div`
  width: ${(props) => (props.size ? props.size : "18px")};
  min-width: ${(props) => (props.size ? props.size : "18px")};
  height: ${(props) => (props.size ? props.size : "18px")};

  &:hover {
    cursor: help;
  }
`;

const Icon = styled.img`
  width: 100%;
  padding-top: ${(props) => (props.paddingtop ? props.paddingtop : "1px")};
`;

export default ({
  tip,
  tipId,
  paddingTop,
  position = "top",
  size,
  delay = 500,
  clickable = 0,
}) => {
  return (
    <>
      <TipIcon
        data-tooltip-id={tipId}
        data-tooltip-html={tip}
        data-tooltip-place={position}
        data-tooltip-delay-show={delay}
        onClick={(e) => e.stopPropagation()}
        size={size}
      >
        <Icon src={tipIcon} paddingtop={paddingTop} />
      </TipIcon>
      <Tooltip id={tipId} className="tooltip" clickable={clickable ? 1 : 0} />
    </>
  );
};
